"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddPayCode = void 0;
const fetchClient_1 = require("../../client/fetchClient");
const contexts_1 = require("../../contexts");
const logger_1 = require("../../logger");
const react_query_1 = require("react-query");
const paths_1 = require("../../paths");
const utils_1 = require("../../utils");
function useAddPayCode(props) {
    const { clientName, currentStage } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { data, isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const usageLocation = props.usageLocation;
    if (!props.shouldFetch) {
        return undefined;
    }
    const addPayCode = (payCodeInputBody) => {
        mutate({
            path: (0, paths_1.ADD_PAY_CODES_API)(props.employeeId || ''),
            method: 'POST',
            body: {
                employeeId: props.employeeId,
                payCodeInputBody: payCodeInputBody
            },
            metaData: {
                apiName: 'addPayCode',
                clientName
            },
            usageLocation
        }, {
            onSuccess: () => {
                utils_1.Emitter.emit(utils_1.taaEvents.ADD_PAY_CODE, { responseCode: 200 });
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PAY_CODES_ADD.COUNT,
                    dimensions
                });
            },
            onError: (error) => {
                utils_1.Emitter.emit(utils_1.taaEvents.ADD_PAY_CODE, {
                    data: error,
                    responseCode: error.statusCode || 500
                });
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PAY_CODES_ADD_ERROR.COUNT,
                    dimensions
                });
            }
        });
    };
    return {
        addPayCodeState: {
            loading,
            data: data,
            error: error || null
        },
        addPayCode
    };
}
exports.useAddPayCode = useAddPayCode;
